export const INTERCOM_ACTIVE_USERS_REPORT_SUCCESS = 'SUCCESS';
export const INTERCOM_ACTIVE_USERS_REPORT_ERROR = 'ERROR';
export const INTERCOM_ACTIVE_USERS_REPORT_LOADING = 'LOADING';
